jQuery(document).ready(function ($) {

    // アコーディオン
    $('.accordion_one .ac_header').click(function () {
      $(this).next('.ac_inner').slideToggle();
      $(this).toggleClass('open');
    });

    // モーダルを開く
    $('.js-modal-open').on('click', function () {
      var target = $(this).data('target');
      var modal = document.getElementById(target);

      scrollPosition = $(window).scrollTop();
      $('body').addClass('fixed').css({ top: -scrollPosition });
      $(modal).fadeIn();

      return false;
    });

    // モーダルを閉じる
    $('.js-modal-close').on('click', function () {
      $('body').removeClass('fixed');
      window.scrollTo(0, scrollPosition);
      $('.js-modal').fadeOut();

      return false;
    });

  });